// extracted by mini-css-extract-plugin
export var logo = "_lr-2";
export var logoWrapper = "_lr-1";
export var strip = "_lr-0";